<ng-container *transloco="let _t">

<div *ngIf="showChart" id="echarts"
    echarts [options]="options" [theme]="theme" class="canvas-holder" 
    (chartClick)="chartClick($event)">
</div>

<p *ngIf="currentLabel==null && showChart" class="text-center" >
  Cliquer sur une part pour filtrer les établissements correspondants
</p>

<p *ngIf="currentLabel!=null" class="text-center vcenter" >
  Catégorie affichée : 
  <strong [style]="'color: '+currentLabelColor">{{ _t('app-synthesis-piechart-strong-0') }}{{currentLabel}}</strong>
  <br>
<button mat-raised-button id="cancelFilter" (click)="chartClick(null)"
  >
  {{ _t('delete-filter') }}
</button>
</p>

</ng-container>